



















import { Component, Prop, Vue, Watch, Mixins, Emit } from 'vue-property-decorator';
import Selection from '@/components/extrinsics/Selection.vue';
import Executor from '@/components/extrinsics/Executor.vue';
import Argurments from '@/components/extrinsics/Arguments.vue';
import ExtrinsicMixin from '@/utils/mixins/extrinsicsMixin'
import Connector from '@vue-polkadot/vue-api';
import extractParams from '@/components/storage/extractParams'
import { getTypeDef } from '@polkadot/types';
import { TypeDef } from '@polkadot/types/types';
import jsonrpc from '@polkadot/types/interfaces/jsonrpc';


const components = {
  Selection,
  Executor,
  Argurments,
}

@Component({ components })
export default class Constants extends Mixins(ExtrinsicMixin) {

  public mounted(): void {
    const { api } = Connector.getInstance()
    this.setSection(api.rpc)
  }

  protected handleMethod(value: string) {
    const { fnSection } = this.getFnMethodAndSection();
    this.handleMethodSelection(value)

    const params: any[] = jsonrpc[fnSection][value].params;
    console.log('params',params);
  
    this.setArgs(params)
  }

  @Emit('click')
  public handleClick() {
    // TODO: send Map<> with name (key) and type (meta.type.asPlain)
    const { fnMethod, fnSection } = this.getFnMethodAndSection();
    const constantCodecPromise = this.getSection();
    const key = { name: `${fnSection}::${fnMethod}`, type: 'any' };
    
    return { key, method: this.getSection(), args: this.mapArgs() }
  }

    get disabled() {
    return this.hasArgs() && !this.mapArgs().filter(v => !!v).length 
  }
  

}
